<script setup lang="ts">
import {useLoadingStore} from '@/stores/loading'
const loadingStore = useLoadingStore()

</script>

<template>
  <!-- Global Loading Overlay -->
  <!--
         class="fixed inset-0 z-50 flex items-center justify-center bg-cover bg-center backdrop-blur-sm"
    :style="{ backgroundImage: `url(${bgImage})` }"
   -->
  <div
    v-if="loadingStore.isGlobalLoading"
    class="fixed inset-0 z-50 flex items-center justify-center bg-white/40 backdrop-blur-sm"
  >
    <div class="animate-spin h-12 w-12 rounded-full border-4 border-primary border-t-transparent"></div>
  </div>
</template>

<style scoped>

</style>
